import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { ParameterProvider } from "cw-backend";
import moment from "moment";
import { Attachment } from "../../../../../../../../shared/cw-backend/models/operational/medical/attachment/attachment";
import { Eartefact } from "../../../../../../../../shared/cw-backend/models/others/eartefact";
import { AttachmentProvider } from "../../../../../../../../shared/cw-backend/providers/operational/medical/attachment.provider";
import { PageOptions } from "../../../../../../../../shared/cw-utils/cw-utils.service";
import { SnackBarService } from "../../../../../../../../shared/cw-utils/snackbar.service";

@Component({
    selector: "app-patient-attachment",
    templateUrl: "./patient-attachment.component.html",
    styleUrls: ["./patient-attachment.component.scss"],
})
export class PatientAttachmentComponent implements OnInit {
    AttachmentGroup: FormGroup;
    pageOptions: PageOptions;
    selectedFile: File;
    attachmentList = new Array<Attachment>();
    file: string;
    pdfSrc: any = null;
    eartefact = new Eartefact();
    attachment = new Attachment();
    zoom: any = "page-width";
    isSmallScreen = window.innerWidth;
    showHistoryMobile = false;
    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;

    constructor(
        private attachmentProvider: AttachmentProvider,
        private _formBuilder: FormBuilder,
        private fuseProgressBarModule: FuseProgressBarService,
        private snackbar: SnackBarService,
        private parameterProvider: ParameterProvider,
        private _matDialog: MatDialog,
        private sanitizer: DomSanitizer,
        public dialogRef: MatDialogRef<PatientAttachmentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.pageOptions = new PageOptions();
    }

    ngOnInit() {
        this.AttachmentGroup = this.createAttachmentForm();
        this.pageOptions.argument = null;
        this.getListByParameter();
    }

    @HostListener("window:resize", ["$event"]) onResize(event) {
        this.isSmallScreen = window.innerWidth;
    }

    isMobileView(): boolean {
        return this.isSmallScreen < 960;
    }

    showAttachmentHistory() {
        this.showHistoryMobile = true;
    }

    returnToAttachmentForm() {
        this.showHistoryMobile = false;
    }

    getListByParameter() {
        this.parameterProvider
            .getParameterByName("ATTACHMENT_IN_STORAGE")
            .then((res) => {
                if (res.body.value == "1") {
                    this.getAttachmentFromStorage();
                } else {
                    this.getAttachment();
                }
            });
    }

    createAttachmentForm(): FormGroup {
        return this._formBuilder.group({
            id: [null],
            name: new FormControl(null),
            dated: new FormControl(
                moment(this.data.dateSchedule).format("YYYY-MM-DD"),
            ),
            eartefact: new FormControl(null),
            performer: new FormControl(
                this.data.performer ? this.data.performer : null,
            ),
            insurance: new FormControl(
                this.data.patient ? this.data.patient.insurance : null,
            ),
            patient: new FormControl(
                this.data.patient ? this.data.patient : null,
            ),
            type: new FormControl(1),
        });
    }

    onFileSelected(event) {
        this.pdfSrc = null;
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }

        this.file = this.selectedFile.type;
        this.AttachmentGroup.controls["name"].setValue(
            this.removeAcentos(this.selectedFile.name),
        );
        this.eartefact = new Eartefact();
        this.generateFile(this.selectedFile);
    }

    removeAcentos(texto: string): string {
        return texto
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // remove acentos
            .replace(/\s+/g, "_"); // substitui espaços por _
    }

    generateFile(file: File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.pdfSrc = reader.result as string;
            this.eartefact.content = this.pdfSrc;
            this.eartefact.type = file.type;
            this.eartefact.dateAt = new Date(this.data.dateSchedule);
            this.eartefact.notes = this.removeAcentos(file.name);
            this.eartefact.name = this.removeAcentos(file.name);

            switch (file.type) {
                case "application/pdf":
                    this.file = "pdf";

                    break;

                case "image/png":
                    this.file = "image";

                    break;

                case "image/jpeg":
                    this.file = "image";

                    break;

                case "video/mp4":
                    this.file = "video";

                    break;

                default:
                    this.file = "notFile";

                    break;
            }
        };
        reader.onerror = (error) => {};
    }

    getAttachment(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 15;
                break;
        }

        this.pageOptions.fieldSort = "dated";
        this.pageOptions.sortDirection = "desc";

        this.attachmentProvider
            .getPageByTypeAndPatientId(
                this.pageOptions,
                this.data.patient.id,
                1,
            )
            .then((attachment) => {
                this.attachmentList = attachment.body.content;
                const dados = attachment.body.content;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;

                this.fuseProgressBarModule.hide();
            })
            .catch((error) => {
                this.fuseProgressBarModule.hide();
            });
    }

    getAttachmentFromStorage(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 15;
                break;
        }

        this.pageOptions.fieldSort = "dated";
        this.pageOptions.sortDirection = "desc";

        this.attachmentProvider
            .getPageByTypeAndPatientIdStorage(
                this.pageOptions,
                this.data.patient.id,
                1,
            )
            .then((attachment) => {
                this.attachmentList = attachment.body.content;
                const dados = attachment.body.content;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;

                this.fuseProgressBarModule.hide();
            })
            .catch((error) => {
                this.fuseProgressBarModule.hide();
            });
    }

    getColorChip(type) {
        switch (type) {
            case "application/pdf":
                return "primary";

                break;

            case "image/png":
                return "accent";

                break;

            case "image/jpeg":
                return "accent";

                break;

            case "video/mp4":
                return "warn";

                break;

            default:
                return "none";

                break;
        }
    }

    getIconChip(type) {
        switch (type) {
            case "application/pdf":
                return "picture_as_pdf";

                break;

            case "image/png":
                return "photo_library";

                break;

            case "image/jpeg":
                return "photo_library";

                break;

            case "video/mp4":
                return "video_library";

                break;

            default:
                return "content_copy";

                break;
        }
    }

    insert() {
        if (this.eartefact.content == null) {
            this.snackbar.warnMessage("Nenhum arquivo selecionado!");
        }

        this.AttachmentGroup.controls["eartefact"].setValue(this.eartefact);

        let data = this.AttachmentGroup.getRawValue();

        const confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: true,
            },
        );

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.componentInstance.deleteMessage = `Deseja adicionar o anexo: ${this.selectedFile.name}`;
        confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fuseProgressBarModule.show();

                this.parameterProvider
                    .getParameterByName("ATTACHMENT_IN_STORAGE")
                    .then((res) => {
                        if (res.body.value == "1") {
                            this.attachmentProvider
                                .insertStorage(data)
                                .then((response) => {
                                    this.getListByParameter();
                                    this.cancel();
                                    this.AttachmentGroup.controls[
                                        "name"
                                    ].setValue(null);
                                    this.AttachmentGroup =
                                        this.createAttachmentForm();
                                    this.fuseProgressBarModule.hide();
                                });
                        } else {
                            this.attachmentProvider
                                .insert(data)
                                .then((response) => {
                                    this.getListByParameter();
                                    this.cancel();
                                    this.AttachmentGroup.controls[
                                        "name"
                                    ].setValue(null);
                                    this.AttachmentGroup =
                                        this.createAttachmentForm();
                                    this.fuseProgressBarModule.hide();
                                });
                        }
                    });
            }
        });
    }

    download(file) {
        const linkSource = file.eartefact.content;
        const downloadLink = document.createElement("a");
        const fileName = file.eartefact.name;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    deleteAttachement(id) {
        this.fuseProgressBarModule.show();

        const confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: true,
            },
        );

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fuseProgressBarModule.hide();

                this.parameterProvider
                    .getParameterByName("ATTACHMENT_IN_STORAGE")
                    .then((res) => {
                        if (res.body.value == "1") {
                            this.attachmentProvider
                                .deleteStorage(id)
                                .then((res) => {
                                    this.getListByParameter();
                                    this.cancel();
                                    this.fuseProgressBarModule.hide();
                                });
                        } else {
                            this.attachmentProvider.delete(id).then((res) => {
                                this.getListByParameter();
                                this.cancel();
                                this.fuseProgressBarModule.hide();
                            });
                        }
                    });
            } else {
                this.fuseProgressBarModule.hide();
            }
        });
    }

    selectRow(attachment) {
        this.attachment = attachment;
        this.AttachmentGroup.controls["name"].disable();
        this.openPreviewDocument(attachment);
        this.returnToAttachmentForm();
    }

    openPreviewDocument(row) {
        this.pdfSrc = row.eartefact.content;

        switch (row.eartefact.type) {
            case "application/pdf":
                this.file = "pdf";

                break;

            case "image/png":
                this.file = "image";
                this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(
                    this.pdfSrc,
                );
                break;

            case "image/jpeg":
                this.file = "image";
                this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(
                    this.pdfSrc,
                );
                break;

            case "video/mp4":
                this.file = "video";

                break;

            default:
                this.file = "notFile";

                break;
        }
    }

    cancel() {
        this.pdfSrc = null;
        this.selectedFile = null;
        this.file = null;
        this.attachment = new Attachment();
        this.AttachmentGroup.controls["name"].setValue(null);
        this.AttachmentGroup.controls["name"].enable();
    }

    closeModal() {
        this.dialogRef.close();
    }
}
